import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/index.html", redirect: "/" },
    { path: "/pages/stakingcalculator.html", redirect: "/stakingcalculator" },
    {
      path: "/pages/validatorcalculator.html",
      redirect: "/validatorcalculator",
    },
    { path: "/pages/tutorials.html", redirect: "/tutorials" },
    { path: "pages/Secret_Network_Graypaper_2.0.1_1.pdf", redirect: "/papers" },
    { path: "pages/blog.html", redirect: "/blog" },
    { path: "pages/community.html", redirect: "/community" },
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/blog",
      name: "blog",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => {
        return import("./views/Blog.vue");
      },
    },
    {
      path: "/community",
      name: "community",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => {
        return import("./views/Community.vue");
      },
    },
    {
      path: "/stakingcalculator",
      name: "staking calculator",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => {
        return import("./views/StakingCalculator.vue");
      },
    },
    {
      path: "/validatorcalculator",
      name: "validator calculator",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => {
        return import("./views/ValidatorCalculator.vue");
      },
    },
    {
      path: "/stakingoptimizer",
      name: "staking optimizer",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => {
        return import("./views/StakingOptimizer.vue");
      },
    },

    {
      path: "/tutorials",
      name: "tutorials",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => {
        return import("./views/Tutorials.vue");
      },
    },
    {
      path: "/papers",
      name: "papers",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => {
        return import("./views/Papers.vue");
      },
    },
    {
      path: "/privacypolicy",
      name: "privacy policy",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => {
        return import("./views/PrivacyPolicy.vue");
      },
    },
  ],
});
